//============================
//# hmmetripexport
//============================
import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

export default interface MetRiportExportHead {
    id: number;
    metisHead: number;
    metisHeadName: string;
    beginDate: Date;
    endDate: Date;
    status: number;
    insDate: Date;
    insUser: number;
    modDate: Date;
    modUser: number;
}

export const MetRiportExportHeadDefaultProps: MetRiportExportHead = {
    id: 0,
    metisHead: 1,
    metisHeadName: "-",
    beginDate: new Date(),
    endDate: new Date(),
    status: 2,
    insDate: new Date(),
    insUser: 1,
    modDate: new Date(),
    modUser: 1,
}

export const MetRiportExportHeadValidationRules: ValidationRules = {
    beginDate: [
        (v: Date) => !!v || t("Kotelezo")
    ],
    endDate: [
        (v: Date) => !!v || t("Kotelezo")
    ],
}